import React, { useEffect, useState } from 'react';
import Echo from 'laravel-echo';
import { Row, Card, Button } from 'react-bootstrap';

//Helpers
import { TelaModalLivre } from '../helpers/TelaModal';

//Sessions
import { getUserProduct, removeUserProduct, setListenerProdutoRemovido, getListenerProdutoRemovido } from './eventosessioncred';
import { getToken } from './tokencidtechapi';

//utils
import { getTraducaoTrocaPor as trad } from './getTraducoes';

export const ListenProdutosPedidosConfirmados = ({history,trads,lingua}) => {

    const [new_pedido, setNewPedido] = useState({produtos: []});
    const [statusprods, setProdutosRemovidos] = useState([]);
    const carrinho = getUserProduct();

    useEffect(() => {
        const options = {
            broadcaster: 'pusher',
            key: "a7af8c5ffc1f70d3a522",
            cluster: "us2",
            encrypted: true,
            authEndpoint: "https://regtronweb.com.br/cidtechweb/broadcasting/auth",
            auth: {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                    Accept: 'application/json',
                },
            },
        };
        
        const echo = new Echo(options);        
        echo.channel(`evento.modified`).listen('.pedido.recebido', ev => setNewPedido(ev&&ev?ev:[]));

        //verifica se já foi removido e guardado na sessão
        setProdutosRemovidos(getListenerProdutoRemovido());
    },[]);

    useEffect(() => {        
        if(new_pedido.produtos.length){
            const result = produtosLimiteQtdePedidos(carrinho,new_pedido);            
            if(result&&result.prdutosremovidos&&result.prdutosremovidos.length > 0){   
                setNewPedido({produtos: []});
                setListenerProdutoRemovido(result.prdutosremovidos);
                removeUserProduct();
                setProdutosRemovidos(result.prdutosremovidos);
            }
        }
    },[new_pedido, carrinho]);

    const handleCloseTelaVoltarEscolhaProduto = () => {
        setListenerProdutoRemovido([]);
        setProdutosRemovidos([]);
        setNewPedido({produtos: []});
        history.push('produtos');
    }
    
    if(statusprods.length){
        return (
            <TelaModalLivre btoFechar={false} show={statusprods.length?true:false} handleCloseModal={handleCloseTelaVoltarEscolhaProduto} titulo={trad(trads,'MODALTITLEPRODREMO',lingua)}>
                <Card.Body>
                    {statusprods.map((itens, index) => {
                        return <Row key={index}>{itens.portugues}</Row>;
                    })}
                    <Row className="mt-2">
                        <Button onClick={handleCloseTelaVoltarEscolhaProduto} block>{trad(trads,'MODALBTOPRODREMO',lingua)}</Button>
                    </Row>
                </Card.Body>
            </TelaModalLivre>
        )
    }

    return null;    
}

export const produtosLimiteQtdePedidos = (carrinho = {}, prodslsten = {}) => {
        
    if(!carrinho.produtos){
        return {};
    }

    let prdutosremovidos = [];
    let prdutosmantidos = [];
    prodslsten.produtos.forEach(produto => {
        
        if(produto.qtderestante<=0){
            const a = carrinho.produtos.filter(itens => produto.idsubitems === itens.idsubitems);
            const b = carrinho.produtos.filter(itens => produto.idsubitems !== itens.idsubitems);
            if(a.length){
                prdutosremovidos.push(...a);
            }

            if(b.length){
                prdutosmantidos.push(...b);
            }
        }
    });

    return {prdutosremovidos: prdutosremovidos, prdutosmantidos: prdutosmantidos};
}

export const validaCarrinho = () => {
    let check_carrinho = {
        ...getUserProduct(),
        valido: false
    };
    if(check_carrinho.produtos && check_carrinho.pedido){
        const result = check_carrinho.produtos.filter(itens => itens.idsubitems>0);
        check_carrinho = {
            valido: result.length>0?true:false
        }
    }
    return check_carrinho
}